import { weenatIntl as wintl } from '@weenat/wintl';
import { IrrigationType } from '../../resources/plots';
import { keysOf } from '../../utils';
function useIrrigationTypesOptions() {
    const keys = keysOf(IrrigationType).filter((key) => isNaN(Number(key)));
    return keys.map((key) => {
        return {
            label: wintl.t(key === 'blank' ? 'actions.do_not_fill_in' : `irrigation_types.${key}`, {
                capitalize: true
            }),
            value: IrrigationType[key]
        };
    });
}
export default useIrrigationTypesOptions;
